export const Urls = {
    ChangeStatus: "EventLogs/ChangeStatus"
};
